
export const option = {
  height: "auto",
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  editBtnText: "",
  editTitle: "",
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: false,
  menu: false,
  indexLabel: "序号",
  selection: false,
  viewBtn: false,
  dialogType: "dialog",
  dialogClickModal: false,
  column: [
    {
      label: "期数",
      prop: "repayment",
      display: false,
      formatter: (val, value, label) => {
        return value ? (value + "/" + val['totalRepayment']+'期') : "-";
    },
    },
    {
      label: "还款日期",
      prop: "repaymentDate",
      display: false,
    },
    {
      label: "平台本金",
      prop: "platformPrincipal",
      type: "input",
      display: false,
    },
    {
      label: "平台利息",
      prop: "platformInterest",
      type: "input",
      display: false,
    },
    {
      label: "每月平台租金",
      prop: "duePlatformRent",
      type: "input",
      display: false,
    },
    {
      label: "实付平台金额",
      prop: "paidPlatformRent",
      type: "input",
      display: false,
    },
    {
      label: "实付日期",
      prop: "paidDate",
      span: 24,
      search: false,
      display: false,
    },
    {
      label: "还款状态",
      prop: "repaymentStatus",
      slot:true,
      type: "input",
      display: false,
    },
  ]
};
